import { useCurrentUserEmail } from '../useCurrentUserEmail';

/** True for @innovativedriven.com staff accounts. */
export function useIsInternalUser(): boolean {
  const email = useCurrentUserEmail();
  return email.toLowerCase().endsWith('@innovativedriven.com');
}
